import { DataPointDates } from '../types.js';

/**
 * Gets the timestamp within the time dimension. In the case of the BandChart is always 'center' and 'start' is fallback.
 * @param datapoint - given TimeseriesDatapoint
 * @returns
 */
export const getBandChartTimestamp = (datapoint: DataPointDates): number =>
  datapoint.center?.getTime() ?? datapoint.start.getTime();
